const NavbarLeftInterface = ['about', 'blog', 'contact'];
const NavbarRightInterface = ['subsidiaries', 'products', 'store'];
const CardBusinessInterface = [
  {
    id: 1,
    title: 'ClickSAT',
    text: 'Get as high as 100Mbps on one modem for your business and home use. ',
  },
  {
    id: 2,
    title: 'Bluenet',
    text: 'Superfast Broadband internet at incredibly high speeds.',
  },
  {
    id: 3,
    title: 'Sensaphone',
    text: 'Remote monitoring system and auto dialers with real time alerts.',
  },
  {
    id: 4,
    title: 'iCOM',
    text: 'Remote operations such as load shedding on connected transformers.',
  },
];
const CardSchoolInterface = [
  {
    id: 1,
    title: 'EasyStudy',
    text: 'Get as high as 100Mbps on one modem for your business and home use. ',
  },
  {
    id: 2,
    title: 'BlueSlate 7',
    text: 'Superfast Broadband internet at incredibly high speeds.',
  },
  {
    id: 3,
    title: 'C3 Micro Cloud',
    text: 'Remote monitoring system and auto dialers with real time alerts.',
  },
  {
    id: 4,
    title: 'TeacherApp',
    text: 'Remote operations such as load shedding on connected transformers.',
  },
];
const CardSubsidiariesProductsInterface = [
  {
    id: 1,
    title: 'EasyStudy',
    text: 'Get as high as 100Mbps on one modem for your business and home use. ',
  },
  {
    id: 2,
    title: 'BlueSlate 7',
    text: 'Superfast Broadband internet at incredibly high speeds.',
  },
  {
    id: 3,
    title: 'C3 Micro Cloud',
    text: 'Remote monitoring system and auto dialers with real time alerts.',
  },
  {
    id: 4,
    title: 'TeacherApp',
    text: 'Remote operations such as load shedding on connected transformers.',
  },
  {
    id: 5,
    title: 'C3 Micro Cloud',
    text: 'Remote monitoring system and auto dialers with real time alerts.',
  },
  {
    id: 6,
    title: 'TeacherApp',
    text: 'Remote operations such as load shedding on connected transformers.',
  },
];
const CardPartnerProductsInterface = [
  {
    id: 1,
    title: 'EasyStudy',
    text: 'Get as high as 100Mbps on one modem for your business and home use. ',
  },
  {
    id: 2,
    title: 'BlueSlate 7',
    text: 'Superfast Broadband internet at incredibly high speeds.',
  },
  {
    id: 3,
    title: 'C3 Micro Cloud',
    text: 'Remote monitoring system and auto dialers with real time alerts.',
  },
  {
    id: 4,
    title: 'TeacherApp',
    text: 'Remote operations such as load shedding on connected transformers.',
  },
];
const CardRecentUpdateInterface = [
  {
    id: 1,
    text: 'CBC Towers welcomes PACE to its building. MD Pace, CFO Pace with MD CBC Properties. ',
  },
  {
    id: 2,
    text: 'CBC Towers welcomes PACE to its building. MD Pace, CFO Pace with MD CBC Properties.',
  },
  {
    id: 3,
    text: 'CBC Towers welcomes PACE to its building. MD Pace, CFO Pace with MD CBC Properties.',
  },
  {
    id: 4,
    text: 'CBC Towers welcomes PACE to its building. MD Pace, CFO Pace with MD CBC Properties.',
  },
];
const CoperateClientsInerface = Array.from({ length: 19 }, (_, i) => i + 1);
const SocialMediaInterface = Array.from({ length: 4 }, (_, i) => i + 1);
//   // let subIndex = [...Array(4).keys()];
const FooterLinkInterface = [
  'About',
  'Leadership',
  'Subsidiaries',
  'Careers',
  'Privacy Policy',
  /*'Terms and Conditions',*/
];
const subsidiariesLinkInterface = [
  'energy',
  'gedu',
  'properties',
  'netcomms',
  'infrastructure',
  'survellience',
];

const productsLinkInterface = [
  'CDPR - Certified Data Protection Officier',
  'Data Protection',
  'Veritas Solution',
  'ClickSAT Satellite Internet Service',
  'Digital Office Worker',
  'Educational Technology Innovation',
  'Priviledged Access Solution',
  'Smash Proptect',
  'Sensaphone',
  'iCOM',
  'Servision',
  'Blunet',
  'IBM Solutions',
];

const AboutFocusInterface = [
  {
    id: 1,
    subHeading: 'Our History',
    para1:
      'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa.',
    para2:
      'With a stable and experienced Board, the CBC Group looks, forward o more decades of providing excellent service and building the nation.',
  },
  {
    id: 2,
    subHeading: 'Our Leadership',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
  {
    id: 3,
    subHeading: 'Our People',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
  {
    id: 4,
    subHeading: 'Our Mission',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
  {
    id: 5,
    subHeading: 'Our Vision',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
  {
    id: 6,
    subHeading: 'CBC Towers - Ultra-Modern Storey Building',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
  {
    id: 7,
    subHeading: 'FIrst Certified HCIE in NIgeria',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam facere quasi expedita similique! Nulla architecto cum facere aliquam laborum cupiditate.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quibusdam accusantium laboriosam voluptas, unde debitis autem consequatur architecto soluta repellendus libero, est a porro, sed nostrum!',
  },
];

const blogNewsInterface = [
  {
    id: 1,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',

    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 2,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 3,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos minus libero blanditiis ratione amet architecto ullam quae oluptate temporibus recusandae.',
  },
  {
    id: 4,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
  {
    id: 5,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 6,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
  {
    id: 7,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',

    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 8,
    heading: 'Mentorship',
    para1:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 9,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos minus libero blanditiis ratione amet architecto ullam quae oluptate temporibus recusandae.',
  },
  {
    id: 10,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
];

const blogBlogInterface = [
  {
    id: 1,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 2,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
  {
    id: 3,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
  {
    id: 4,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 5,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },

  {
    id: 6,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 7,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',

    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 8,
    heading: 'Mentorship',
    para1:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
    para2:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 9,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
    para2:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos minus libero blanditiis ratione amet architecto ullam quae oluptate temporibus recusandae.',
  },
  {
    id: 10,
    heading: 'Title of Blog',
    para1:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
    para2:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
];

const leadershipBDInterface = [
  {
    id: 1,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 2,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus nemo, quaerat incidunt, porro sed consequuntur vero veritatis similique ullam earum inventore temporibus eum fugiat quam ipsum magni vel vitae nisi?',
  },
  {
    id: 3,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos minus libero blanditiis ratione amet architecto ullam quae oluptate temporibus recusandae.',
  },
  {
    id: 4,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
  },
  {
    id: 5,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
];

const leadershipSMInterface = [
  {
    id: 1,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },

  {
    id: 2,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
  {
    id: 3,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos minus libero blanditiis ratione amet architecto ullam quae oluptate temporibus recusandae.',
  },
  {
    id: 4,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident, deleniti? Inventore quos debitis, ut incidunt nemo repellat modi! Non culpa quae, nesciunt ad aliquam quibusdam facilis deleniti ut?',
  },
  {
    id: 5,
    heading: 'GBADE ALABI',
    office: 'Chief Executive Officier',
    para: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minima, repudiandae aliquid consequuntur necessitatibus in voluptatem quia, nostrum laboriosam quaerat optio autem doloribus, reiciendis expedita.',
  },
];

const subsidiariesInterface = [
  {
    id: 1,
    subHeading: 'CBC GEDU TECHNOLOGIES',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
  {
    id: 2,
    subHeading: 'CBC INFRASTRUCTURE',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
  {
    id: 3,
    subHeading: 'CBC NETCOMMS',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
  {
    id: 4,
    subHeading: 'CBC ENERGY',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
  {
    id: 5,
    subHeading: 'CBC PROPERTIES',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
  {
    id: 6,
    subHeading: 'CBC SURVEILLANCE',
    para: 'Established in 1984 as City Business Computers, The CBC EMEA Group is an Information Technology Conglomerate with over 3 decades of experience in design, supply and implementation of turnkey IT, communications and security solutions in Africa. With a stable and experienced Board, the CBC Group looks, forward to more decades of providing excellent service and building the nation.',
  },
];

const managementGeduInterface = [
  {
    id: 1,
    image: 'images/generalmanager.png',
    position: 'Managing Director',
    name: 'opeyemi adesina',
  },
  {
    id: 2,
    image: 'images/deputygeneralmanager.png',
    position: 'Deputy General Manager',
    name: 'FUNMIKE ALAWODE',
  },
];

export {
  NavbarLeftInterface,
  subsidiariesLinkInterface,
  productsLinkInterface,
  NavbarRightInterface,
  CardBusinessInterface,
  CardSchoolInterface,
  CardRecentUpdateInterface,
  CoperateClientsInerface,
  SocialMediaInterface,
  FooterLinkInterface,
  AboutFocusInterface,
  blogNewsInterface,
  blogBlogInterface,
  leadershipBDInterface,
  leadershipSMInterface,
  subsidiariesInterface,
  CardSubsidiariesProductsInterface,
  CardPartnerProductsInterface,
  managementGeduInterface,
};
